<script>
import {
  CollectionItemsPageElementMixin,
} from "%/dynamic-component-editor/standard-pages/collection-items-page/collection-items-page-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";

export default {
  name: "CollectionItemsTitle",
  elementPanelSettings: {
    displayName: "Title",
    displayIcon: "material-symbols:title",
    elementGroup: "collectionItemsElements",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [CollectionItemsPageElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      return this.entity?.name ?? "";
    },
  },
};
</script>
